// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"userDetailsCard__msignaturepad___A0dtR","m-signature-pad--body":"userDetailsCard__m-signature-pad--body___2FPxg","m-signature-pad--footer":"userDetailsCard__m-signature-pad--footer___1VmYG","description":"userDetailsCard__description___13ryb","button":"userDetailsCard__button___3AHrE","clear":"userDetailsCard__clear___r0xU1","save":"userDetailsCard__save___1JNaS","m-signature-pad":"userDetailsCard__m-signature-pad___8_dQf","github":"userDetailsCard__github___1lJ2n","userDetailsCard":"userDetailsCard__userDetailsCard___1-qLE"};


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/components/users/UserDetailsCard/userDetailsCard.scss
// module id = 7UVI
// module chunks = client